// extracted by mini-css-extract-plugin
export var container = "WeatherUpdates-module--container--jZbtK";
export var selected = "WeatherUpdates-module--selected--cLeT2";
export var time = "WeatherUpdates-module--time--Cn4Je";